<template>
  <v-app light id="gungho" :data-session-id="this.$session.get('sessionToken')">
    <header-menu/>

    <v-content>
      <div class="progress-wrapper">
        <v-progress-linear
          v-if="loading"
          :indeterminate="true"
          class="mt-0"
          color="blue"
          >
        </v-progress-linear>
      </div>

      <v-container fluid grid-list-lg>
        <v-flex xs12 sm12 md12 xl10 offset-xl1 class="gungho-content">
          <router-view :key="$router.fullPath"></router-view>
        </v-flex>
      </v-container>
    </v-content>

    <footer-menu></footer-menu>
  </v-app>
</template>

<script>
  import Events from '@/api/events'
  import vuetifyToast from 'vuetify-toast'
  import headerMenu from '@/components/widgets/header-menu'
  import footerMenu from '@/components/widgets/footer-menu'

  export default {
    metaInfo: {
      title: 'GENIE',
      titleTemplate: '%s | Gung-Ho'
    },

    data: () => ({
      loading: false,
      loadingCount: 0
    }),

    components: {
      headerMenu, footerMenu
    },

    mounted () {
      Events.$on('toggleLoading', (value) => {
        if (value === true) this.loadingCount += 1
        if (value === false) this.loadingCount -= 1
        if (this.loadingCount < 0) this.loadingCount = 0
        this.loading = this.loadingCount > 0
      })

      Events.$on('error', (message) => {
        vuetifyToast.error(
          message,
          {
            icon: 'mdi-alert-circle',
            timeout: 60000,
            dismissible: true
          }
        )
      })

      Events.$on('toast', (message) => {
        vuetifyToast.show({
          text: message,
          icon: 'mdi-information',
          color: 'default',
          timeout: 10000,
          dismissible: true
        })
      })

      Events.$on('toLogin', () => {
        document.location.href = process.env.LOGIN_URL + '/?to=' + window.location.href
      })

      Events.$on('consoleLog', (data) => {
        console.log(JSON.parse(JSON.stringify(data)))
      })
    },

    beforeDestroy () {
      Events.$off('toggleLoading')
      Events.$off('error')
      Events.$off('toast')
      Events.$off('toLogin')
      Events.$off('consoleLog')
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?49eb26e6